<template>
  <div class="mission__content">
    <div class="mission__label">{{ $t("missions.list.description") }}</div>
    <div class="mission__index">
      <i v-if="missionComplete" class="icon icon-check"></i>
      <template v-else>{{ missionIndex }}</template>
    </div>
    <div class="mission__text" :class="{ 'mission__text--complete': missionComplete }">
      {{ missionData.title }}
    </div>
    <div class="mission__bottom">
      <MissionsListOneInfoRewards
        :index="index"
        :missionRewards="getMissionRewards"
        :missionComplete="missionComplete"
      />
      <div class="mission__progress">
        <div class="mission__progress__header">
          <template v-if="!missionComplete">
            <div class="mission__label">{{ $t("missions.list.progress") }}</div>
            <span>{{ progress }}/{{ missionData.target_count }}</span>
          </template>
          <span v-else>{{ $t("missions.list.done") }}</span>
        </div>

        <ProgressLine class="progress__line--white" :current="getProgressWidth" />
      </div>
    </div>
  </div>
</template>
<script>
import MissionsListOneInfoRewards from "./MissionsListOneInfoRewards";
import ProgressLine from "@/components/Common/ProgressLine";
export default {
  name: "MissionsOneInfo",
  components: {
    MissionsListOneInfoRewards,
    ProgressLine,
  },
  props: {
    missionData: Object,
    index: Number,
    progress: Number,
  },
  computed: {
    missionComplete() {
      return this.missionData.is_complete;
    },
    missionIndex() {
      return `${("0" + (this.index + 1)).slice(-2)}`;
    },
    getMissionRewards() {
      return this.missionData.rewards.slice().reverse();
    },
    getProgressWidth() {
      return (this.progress / this.missionData.target_count) * 100;
    },
  },
};
</script>
